import { render } from "./VerificationSentView.vue?vue&type=template&id=5feb71ee"
import script from "./VerificationSentView.vue?vue&type=script&lang=js"
export * from "./VerificationSentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__